// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"d1d8ca99dfa9e149d87f","293":"73d8388754e55dcd0141","522":"98c20a6f14da4db3bbb1"}[chunkId] + ".js";
};